<template>
  <v-card class="card-wrapper" :class="inverted" hover>
    <v-img :aspect-ratio="1 / 1" position="left bottom" cover class="imagen-seminario" :src="image">
    </v-img>
    <div class="d-flex flex-column px-9" style="flex:1">
      <h5 class="text pt-4" v-text="seminar.name" />
      <div>
        <v-chip class="mt-2 center-text" color="primary" dark>
          Total de videos <b class="ml-2">{{ totalVideos }}</b>
        </v-chip>
      </div>
      <div class="mt-3" style="flex:1">
        {{ seminar.description }}
      </div>
      <div class="d-flex flex-row-reverse pb-6">
        <button class=" cta read-more notranslate mt-6" @click="goTo()">
          Videoteca
        </button>
      </div>
    </div>
  </v-card>
</template>
<script>
import $ from "jquery";

export default {
  name: "Seminar_cell",
  data() {
    return {
      publicPath: $(location).attr("origin") + "/archivos/seminarios/",
      image: null
    };
  },
  props: {
    seminar: Object,
    index: Number
  },
  beforeMount: function() {
    this.image = this.publicPath + this.seminar.image;
  },
  methods: {
    goTo() {
      this.$router.push(this.path);
    }
  },
  computed: {
    path() {
      return { path: `/seminarios/${this.seminar.path}` };
    },
    inverted() {
      return this.index % 2 == 0 ? "flex-row" : "flex-row-reverse";
    },
    totalVideos() {
      return this.seminar.videos.length;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/global";
.card-wrapper {
  display: flex;
  margin-bottom: 32px !important;
}
.imagen-seminario {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  height: 350px !important;
  width: 490px !important;
  min-height: 350px !important;
  min-width: 490px !important;
  max-height: 350px !important;
  max-width: 490px !important;
}

.text {
  width: 100%;
  padding-top: 0px;
  color: black;
  margin-top: 10px;
}

@media (max-width: $screen-lg-min) and (min-width: 500px) {
  .text {
    // color: red;
  }
}

@media only screen and (max-width: $screen-lg-min) {
  .card-wrapper {
    flex-direction: column !important;
  }
  .imagen-seminario {
    max-width: 100% !important;
    width: 100% !important;
    max-height: 390px !important;
    height: 390px !important;
    min-width: auto !important;
  }
  .text {
    // color: blue;
  }
}

@media (max-width: 500px) {
  .card-wrapper{
    margin-bottom: 0px !important;
  }
  .card-wrapper{
    transform: scale(0.85);
  }
  .text {
    // color: green;
  }
}
</style>
